import { render, staticRenderFns } from "./shoot.vue?vue&type=template&id=89a0d2c2&"
import script from "./shoot.vue?vue&type=script&lang=js&"
export * from "./shoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89a0d2c2')) {
      api.createRecord('89a0d2c2', component.options)
    } else {
      api.reload('89a0d2c2', component.options)
    }
    module.hot.accept("./shoot.vue?vue&type=template&id=89a0d2c2&", function () {
      api.rerender('89a0d2c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/shoot.vue"
export default component.exports